export default {
  data() {
    return {
      recordForm: '{}',
      formKeyName: ''
    };
  },
  mounted: function () {
    this.recordFilter();
  },
  methods: {
    recordFilter(name = 'formSearch') {
      this.formKeyName = name;
      this.recordForm = JSON.stringify(this[name]);
    },
    clearFilter(exclude = 'search') {
      const excludeForm = {};
      this.$setFormatData(excludeForm, this[this.formKeyName], exclude);
      const reserForm = JSON.parse(this.recordForm);
      this[this.formKeyName] = Object.assign(reserForm, excludeForm);
      if (this.onPageChange) {
        this.onPageChange({ page: 1 });
      }
    }
  }
};
